<template>
  <b-modal
    id="delete-team-member-modal"
    title="Delete Team Member"
    hide-footer
    @hidden="hiddenHandler"
  >
    <h4 class="mb-2">
      Are you sure you want to delete this member?
    </h4>
    <validation-observer
      ref="formRef"
    >
      <b-form
        autocomplete="off"
        class="p-2"
        @submit.prevent="submitInactivation"
      >
        <validation-provider
          #default="{ errors }"
          name="Reason"
          rules="required"
        >
          <b-form-group
            label="Reason"
            label-for="delete-reason"
          >
            <b-form-select
              id="delete-reason"
              v-model="deleteReason.leaveReasonId"
              text-field="reason.en"
              value-field="id"
              :options="deleteReasons"
            />
            <span class="text-danger"> {{ errors[0] }} </span>
          </b-form-group>
        </validation-provider>
        <validation-provider
          v-if="deleteReason.leaveReasonId == 0"
          #default="{ errors }"
          name="Other Reason"
          rules="required"
        >
          <b-form-group
            label="Other Reason"
            label-for="other-reason"
          >
            <b-form-textarea
              id="other-reason"
              v-model="deleteReason.leaveReasonText"
            />
            <span class="text-danger"> {{ errors[0] }} </span>
          </b-form-group>
        </validation-provider>
      </b-form>
    </validation-observer>
    <div class="d-flex justify-content-around">
      <b-button
        class="mr-1"
        variant="danger"
        :disabled="deletingTeam"
        @click="deleteTeam"
      >
        <b-spinner
          v-if="deletingTeam"
          small
        />
        <span v-else>Yes, Delete member</span>
      </b-button>
      <b-button
        variant="outline-primary"
        @click="$bvModal.hide('delete-team-member-modal')"
      >
        <span>No, keep the member</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BSpinner, BFormSelect, BForm, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal,
    BSpinner,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BForm,
  },
  props: {
    member: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const formRef = ref(null)
    const loading = ref(false)
    const deleteReason = ref({
      leaveReasonId: null,
      leaveReasonText: '',
    })
    const deleteReasons = ref([])
    const fetchDeleteReasons = async () => {
      loading.value = true

      const result = await axiosIns.get('/teams/leave-reasons')
      deleteReasons.value = result.data.data
      deleteReasons.value.unshift({
        id: 0,
        reason: {
          en: 'OTHER',
          ar: 'OTHER',
        },
      })
      loading.value = false
    }
    fetchDeleteReasons()
    const deletingTeam = ref(false)
    const deleteTeam = async () => {
      const res = await formRef.value.validate()
      if (!res) return
      try {
        deletingTeam.value = true
        const PAYLOAD = {}
        if (deleteReason.value.leaveReasonId === 0) {
          PAYLOAD.leaveReasonText = deleteReason.value.leaveReasonText
          PAYLOAD.leaveReasonId = 'OTHER'
        } else {
          PAYLOAD.leaveReasonText = ''
          PAYLOAD.leaveReasonId = deleteReason.value.leaveReasonId
        }

        await axiosIns.delete(`/teams/member/${props.member.id}`, {
          data: PAYLOAD,
        })
        ctx.root.$bvModal.hide('delete-team-member-modal')
        ctx.emit('member-deleted')
      } finally {
        deletingTeam.value = false
      }
    }

    const hiddenHandler = () => {
      deleteReason.value.leaveReasonText = ''
      deleteReason.value.leaveReasonId = null
    }
    return {
      deleteTeam,
      deletingTeam,
      deleteReasons,
      formRef,
      loading,
      hiddenHandler,
      deleteReason,
      required,
    }
  },
}
</script>
